import { useState } from "react";
import { Staff } from "../../types/staff";
import { useEditMode } from "../../context/EditModeContext";
import SubHeadings from "../../components/SubHeadings";
import CustomInput from "../../components/CustomInput";

interface PersonalInformationProps {
  staff?: Staff;
}

export default function ExitInfo({ staff }: PersonalInformationProps) {
  const [formData, setFormData] = useState<Staff>({} as Staff);
  const { isEditing } = useEditMode();

  const handleInputChange = (
    event: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <div className="px-4 md:px-9 flex flex-col-reverse md:flex-row divide-x divide-neutral-50 gap-9">
      <div className="flex flex-col gap-7 w-full py-7">
        <div className="flex justify-between items-center gap-4">
          <SubHeadings text="Exit Details" />
          <aside className="text-xs font-medium text-error-500">
            *To be filled by HR
          </aside>
        </div>
        <form className="">
          <div className="grid md:grid-cols-2 2xl:grid-cols-3 gap-7 items-start">
            <div className="flex flex-col min-h-full">
              <CustomInput
                name="noticePeriod"
                label="Notice period"
                type="text"
                readOnly
                placeholder="------"
                value={staff?.noticePeriod}
                onChange={handleInputChange}
                inputClassName=""
              />
            </div>
            <div className="flex flex-col min-h-full">
              <CustomInput
                name="noticePeriodStatus"
                label="Notice period status"
                type="text"
                placeholder="------"
                readOnly
                value={staff?.noticePeriodStatus}
                onChange={handleInputChange}
                inputClassName=""
              />
            </div>
            <div className="flex flex-col min-h-full">
              <CustomInput
                name="reasonForLeaving"
                label="Reason for leaving"
                type="text"
                readOnly
                placeholder="------"
                value={staff?.reasonForLeaving}
                onChange={handleInputChange}
                inputClassName="w-full"
              />
            </div>
            <div className="flex flex-col min-h-full">
              <CustomInput
                name="duesCollected"
                label="All school related dues/resources collected?"
                type="text"
                placeholder="------"
                readOnly
                value={
                  staff?.duesCollected === true
                    ? "Yes"
                    : staff?.duesCollected === false
                      ? "No"
                      : ""
                }
                onChange={handleInputChange}
                inputClassName="w-full"
              />
            </div>
            <div className="flex flex-col min-h-full">
              <CustomInput
                name="bankName"
                label="Bank name"
                type="text"
                placeholder="------"
                readOnly
                value={staff?.bankName}
                onChange={handleInputChange}
                inputClassName="w-full"
              />
            </div>
            <div className="flex flex-col min-h-full">
              <CustomInput
                name="ifscCode"
                label="IFSC code"
                type="text"
                readOnly
                placeholder="------"
                value={staff?.ifscCode}
                onChange={handleInputChange}
                inputClassName="w-full"
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
